import React from "react";
import { HashRouter, Route } from "react-router-dom";

import Home from "../screens/Home/Home";
import ContactUs from "../screens/ContactUs/ContactUs";
import ChangePassword from "../screens/ChangePassword/ChangePassword";
import CurrentBalance from "../screens/CurrentBalance/CurrentBalance";
import FAQ from "../screens/FAQ/FAQ";
import PersonalDetails from "../screens/PersonalDetails/PersonalDetails";
import NextOfKin from "../screens/NextOfKin/NextOfKin";
import EmployerDetails from "../screens/EmployerDetails/EmployerDetails";
// import PensionCalculator from "../screens/PensionCalculator/PensionCalculator";
import PensionCalculatorWebview from "../screens/PensionCalculator/PensionCalculatorWebview";
import AddRole from "../screens/AddRole/AddRole";
import Login from "../screens/Login/Login";
import Register from "../screens/Register/Register";
import SelfService from "../screens/SelfService/SelfService";
// import Enrollment from "../screens/Enrollment/Enrollment";
import DownloadForms from "../screens/DownloadForms/DownloadForms";
import TransactionDetails from "../screens/TransactionDetails/TransactionDetails";
import FundPrices from "../screens/FundPrices/FundPrices";
import PrivacyPolicy from "../screens/PrivacyPolicy/PrivacyPolicy";
// import Onboarding from "../screens/Onboarding/Onboarding";
import RsaPinRegistration from "../screens/RSAPinRegistration/Onboarding";
import Contribution from "../screens/Contribution/Contribution";
import Withdrawl from "../screens/Withdrawl/Withdrawl";
import Referral from "../screens/Referral/Referral";
import RewardSystem from "../screens/RewardSystem/RewardSystem";
import ForgotPassword from "../screens/ForgotPassword/ForgotPassword";
import NewPassword from "../screens/ForgotPassword/NewPassword";
import ScheduleSubmissionReport from "../screens/ScheduleSubmissionReport";
import OutputScreen from "../screens/OutputScreen";
import RequestEmployerCode from "../screens/RequestEmployerCode";
import RSAPinDublicated from "../screens/RSAPinDublicated/Onboarding";
import RSANINImplementation from "../screens/RSANINImplementation/Onboarding";
import MicroPensionDublicated from "../screens/MicroPensionDublicated/Onboarding";
import MPNINImplementation from "../screens/MPNINImplementation/Onboarding";
// import ExpressionOfInterest from "../screens/ExpressionOfInterest";
import ExpressionOfInterestWebview from "../screens/ExpressionOfInterest/ExpressionOfInterestWebview";
import CyberPaySuccess from "../screens/CyberPaySuccess";
import Consent from "../screens/Consent/Consent";
import RegistrationToken from "../screens/RegistrationToken";
import UserActivation from "../screens/Register/UserActivation";

export default function Router() {
  return (
    <HashRouter>
      <Route path="/" exact component={Home} />
      <Route path="/contactus" exact component={ContactUs} />
      <Route path="/changepassword" exact component={ChangePassword} />
      <Route path="/currentbalance" exact component={CurrentBalance} />
      <Route path="/faq" exact component={FAQ} />
      <Route path="/personaldetails" exact component={PersonalDetails} />
      <Route path="/nextofkin" exact component={NextOfKin} />
      <Route path="/employeedetails" exact component={EmployerDetails} />
      <Route
        path="/pensioncalculator"
        exact
        component={PensionCalculatorWebview}
      />
      <Route path="/addrole" exact component={AddRole} />
      <Route path="/login" exact component={Login} />
      <Route path="/register" exact component={Register} />
      <Route path="/selfservice" exact component={SelfService} />
      {/* <Route path="/enrollment" exact component={Enrollment} /> */}
      <Route path="/downloadforms" exact component={DownloadForms} />
      <Route path="/transactiondetails" exact component={TransactionDetails} />
      <Route path="/fundprices" exact component={FundPrices} />
      <Route path="/privacypolicy" exact component={PrivacyPolicy} />
      <Route path="/consentscreen" exact component={Consent} />
      <Route path="/onboarding" exact component={MicroPensionDublicated} />
      {/* <Route path="/onboarding" exact component={Onboarding} /> */}
      <Route path="/contribution" exact component={Contribution} />
      <Route path="/withdrawal" exact component={Withdrawl} />
      <Route path="/rsapin" exact component={RsaPinRegistration} />
      <Route path="/referral" exact component={Referral} />
      <Route path="/rewardsystem" exact component={RewardSystem} />
      <Route path="/forgotpassword" exact component={ForgotPassword} />
      <Route path="/useractivation" exact component={UserActivation} />
      <Route path="/newpassword" exact component={NewPassword} />
      <Route
        path="/submissionreport"
        exact
        component={ScheduleSubmissionReport}
      />
      <Route path="/outputscreen" exact component={OutputScreen} />
      <Route
        path="/requestemployercode"
        exact
        component={RequestEmployerCode}
      />
      <Route path="/rsapin-uba" exact component={RSAPinDublicated} />
      <Route path="/rsapin-2" exact component={RSAPinDublicated} />
      <Route path="/rsapin-3" exact component={RSANINImplementation} />
      <Route path="/rsapin-4" exact component={MPNINImplementation} />
      <Route
        path="/expression-of-interest"
        exact
        component={ExpressionOfInterestWebview}
      />
      <Route path="/cyberpay-success" exact component={CyberPaySuccess} />
      <Route path="/registration-token" exact component={RegistrationToken} />
      {/* <Route
        path="/micropension-duplicate"
        exact
        component={MicroPensionDublicated}
      /> */}
    </HashRouter>
  );
}
